import React, { memo, useState } from 'react'

import {
  Adjustments,
  Button,
  ClosingDropdown,
  Icon,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  func, node, number, shape, string,
} from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import SettingsPanel from './Components/SettingsPanel/SettingsPanel'

const settingsIcon = <Icon svgComponent={Adjustments} size={iconSize} notSpace color="darker" />

// Controlled: the composer owns the settings so the next send reads them. stackedControls
// are the composer controls that no longer fit the row; the popover lists them above its
// own settings.
function GenerationSettings({ settings, onChange, stackedControls = null }) {
  const t = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  // Not portalled: usePanelDismiss closes the assistant on any pointerdown outside
  // the panel's DOM, so a popover in <body> would close the panel on first touch.
  return (
    <ClosingDropdown
      content={<SettingsPanel settings={settings} stackedControls={stackedControls} onChange={onChange} />}
      isSimpleContent
      size="medium"
      placement="top"
      contentClassName="generation-settings__popover"
      className="generation-settings"
      onOpenChange={setIsOpen}
    >
      <Button
        type="secondary"
        variant="only-icon"
        size="small"
        actionType="button"
        icon={settingsIcon}
        customClass={classnames(
          'generation-settings__trigger',
          isOpen && 'generation-settings__trigger--open',
        )}
        aria-label={t('imageAssistantPanel.createTab.composer.settings.trigger')}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      />
    </ClosingDropdown>
  )
}

GenerationSettings.propTypes = {
  settings: shape({
    aspectRatio: string.isRequired,
    variations: number.isRequired,
  }).isRequired,
  onChange: func.isRequired,
  stackedControls: node,
}

export default memo(GenerationSettings)
